/* Product info tabs: [data-wallace-tabs] > .pbt-tablist[role=tablist] + [role=tabpanel] panels. */
(function () {
  if (window.WallaceTabs) {
    window.WallaceTabs.init();
    return;
  }

  function setup(root) {
    if (root.__wallaceTabs) return;
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return; // single panel, nothing to switch
    root.__wallaceTabs = true;

    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));

    function panelFor(tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    }

    function select(tab, moveFocus) {
      tabs.forEach(function (t) {
        var active = t === tab;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
        var panel = panelFor(t);
        if (panel) panel.hidden = !active;
      });
      // preventScroll: the info column is sticky and scrolls internally, so never let
      // focus() jump it or the page.
      if (moveFocus) tab.focus({ preventScroll: true });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab, false);
      });
    });

    tablist.addEventListener('keydown', function (event) {
      var index = tabs.indexOf(document.activeElement);
      if (index === -1) return;
      var next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = tabs.length - 1;
      else return;
      event.preventDefault();
      select(tabs[next], true);
    });
  }

  function init() {
    document.querySelectorAll('[data-wallace-tabs]').forEach(setup);
  }

  window.WallaceTabs = { init: init };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
